import { FormArray } from '@ngneat/reactive-forms';
import { FormRepeatable } from '../../../../core/models/form-group-mapping.model';

export function RepeatableMinLength(minLength: number) {
  return (control: FormArray<FormRepeatable>) => {
    if (control.controls.length < minLength) {
      return { RepeatableMinLength: true };
    }
  };
}
